import { TableHoverActions } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../hooks'

interface UmbrellaOrganizationsListTableHoverActionsProps {
  organizationId: string
  positionInList: number
  umbrellaOrganizationUrl: string
}

export const UmbrellaOrganizationsListTableHoverActions = ({
  organizationId,
  positionInList,
  umbrellaOrganizationUrl,
}: UmbrellaOrganizationsListTableHoverActionsProps): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()

  const handleGoToOrganization = useCallback(() => {
    track('xxx - Practice Layer Client Clicked (Client)', {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      client_id: organizationId,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      position_in_list: positionInList,
    })
    window.open(`/${umbrellaOrganizationUrl}`, '_blank')
  }, [organizationId, positionInList, track, umbrellaOrganizationUrl])

  return (
    <TableHoverActions>
      <TableHoverActions.Item
        icon="squareArrowOutUpRight"
        label={t('umbrella_organizations.organizations_table.goToOrganization')}
        onClick={handleGoToOrganization}
      />
    </TableHoverActions>
  )
}
